export const baseURL = "/api/v1";
// export const baseURL = "https://triadmasterclass-cffec5d4g6djdvav.westeurope-01.azurewebsites.net/api/v1";
